import React, { useMemo, useState } from "react";
import RoleManager from "../RoleManagement/RoleManager"
import Pagination from "../../Pagination/Pagination"

const StaffMemberTable = ({ staffMembers, onEdit, onAdd, onDelete, totalPages, currentPage, onPageChange }) => {

const [isRoleManagement, setIsRoleManagement] = useState(false);
const [loading, setLoading] = useState(false);

  const userDetails = useMemo(() => JSON.parse(sessionStorage.getItem("userDetails")) || {}, []);
  const filteredRoles = useMemo(() => {
    const storedRoles = JSON.parse(sessionStorage.getItem("filteredRoles")) || [];
    return storedRoles.filter((role) => {
      const permissions = userDetails?.role?.permissions || [];
      const resourceEntry = permissions.find((entry) => entry.resource === role.roleName);
      return role.roleName === "Admin" && resourceEntry?.actions.includes("Create");
    });
  }, [userDetails]);

  const rolesOptions = useMemo(() => {
    return filteredRoles.map((role) => ({
      value: role.roleId,
      label: role.roleName,
    }));
  }, [filteredRoles]);

  const isActionAllowed = (resource, action) => {
    const permissions = userDetails?.role?.permissions || [];
    const resourceEntry = permissions.find((entry) => entry.resource === resource);
    return resourceEntry?.actions.includes(action) || false;
  };

  const getRoleName = (roleId) => {
    return filteredRoles.find((role) => role.roleId === roleId)?.roleName || "Unknown";
  };

  const openRoleManagement = () => {
    setLoading(true);
    setTimeout(() => {
      setIsRoleManagement(true);
      
    }, 1000); // Simulate loading
    setLoading(false);
  };

  const closeRoleManagement = () => {
    setIsRoleManagement(false);
  };

  return (
    <>
    {isRoleManagement ? (
      <RoleManager
      onclose={closeRoleManagement}
      />
    ) : (
      <>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
        <button
          onClick={onAdd}
          style={{
            padding: "10px 20px",
            backgroundColor: (rolesOptions.length === 0) ? "#ccc" : "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: (rolesOptions.length === 0) ? "not-allowed" : "pointer"
          }}
          disabled={rolesOptions.length === 0}
        >
          Add Admin
        </button>
        <button
          style={{
            padding: "10px 20px",
            backgroundColor: loading ? "#ccc" : "#007bff",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: loading ? "not-allowed" : "pointer"
          }}
          disabled={loading}
          onClick={openRoleManagement}
        >
          Manage Roles
        </button>
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>First Name</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Last Name</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Email</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Phone Number</th>
            <th style={{ border: "1px solid #ddd", padding: "8px" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {staffMembers.map((member) => {
            const role = getRoleName(member.roleId);
            const canEdit = isActionAllowed(role, "Edit");
            const canDelete = isActionAllowed(role, "Delete");

            return (
              <tr key={member._id}>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{member.firstName}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{member.lastName}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{member.email}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>{member.phoneNumber}</td>
                <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                  <button
                    disabled={!canEdit}
                    onClick={() => onEdit(member)}
                    style={{
                      marginRight: "10px",
                      padding: "5px 10px",
                      backgroundColor: canEdit ? "#28a745" : "#ccc",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: canEdit ? "pointer" : "not-allowed",
                    }}
                  >
                    Edit
                  </button>
                  <button
                    disabled={!canDelete}
                    onClick={() => onDelete(member._id, member.roleId)}
                    style={{
                      padding: "5px 10px",
                      backgroundColor: canDelete ? "#dc3545" : "#ccc",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: canDelete ? "pointer" : "not-allowed",
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={onPageChange} />
    </>
    )}
    </>
  );
};

export default StaffMemberTable;
